export const Anchor = {
  color: {
    light: '#000000',
    dark: '#000000'
  },
  hover: {
    textDecoration: 'none'
  }
};
